import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'mbs-card-header',
  templateUrl: './card-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet]
})
export class CardHeaderComponent {
  public readonly headerIco = input<string>(null, { alias: 'ico' });
  public readonly headerTitle = input<string>(null, { alias: 'title' });

  protected readonly headerTemplate = contentChild<TemplateRef<unknown>>(TemplateRef);
}
